<div class="flex h-screen overflow-hidden bg-gray-100">
  <app-sidebar />

  <div class="flex-1 flex flex-col overflow-hidden">
    <div class="flex items-center justify-end gap-3 px-6 py-3 bg-white border-b border-gray-200 min-h-14"></div>

    <div class="flex-1 overflow-y-auto p-6">
      <router-outlet />
    </div>
  </div>
</div>
